<div class="client-page-content time">
  <div class="content-header">
    <h2>{{ 'CLIENT.clientTime.title' | translate }}</h2>
    <p>{{day?.day | dateFix | date:'fullDate' }}</p>
  </div>
  <div class="row">
    <div class="col" *ngIf="hoursExistsInPeriod(day?.hours, 'morning')">
      <ul class="options text-center" >
        <li class="option-title">{{ 'CLIENT.clientTime.morning' | translate }}</li>
        <ng-container *ngFor="let hour of day?.hours">
          <li (click)="selectHour(hour)" *ngIf="hourToString(hour?.start) === 'morning'">
            <a class="option" >{{ formatTime(hour?.start) }}</a>
            <!-- <a class="option" >{{ hour?.start }} - {{ hour?.end }}</a> -->
          </li>
        </ng-container>
      </ul>
    </div>
    <div class="col" *ngIf="hoursExistsInPeriod(day?.hours, 'afternoon')">
      <ul class="options text-center" >
        <li class="option-title">{{ 'CLIENT.clientTime.afternoon' | translate }}</li>
        <ng-container *ngFor="let hour of day?.hours" >
          <li (click)="selectHour(hour)" *ngIf="hourToString(hour?.start) === 'afternoon'">
            <a class="option">{{ formatTime(hour?.start) }}</a>
            <!-- <a class="option">{{ hour?.start }} - {{ hour?.end }}</a> -->
          </li>
        </ng-container>
      </ul>
    </div>
    <div class="col" *ngIf="hoursExistsInPeriod(day?.hours, 'night')">
      <ul class="options text-center" >
        <li class="option-title">{{ 'CLIENT.clientTime.night' | translate }}</li>
        <ng-container *ngFor="let hour of day?.hours">
          <li  (click)="selectHour(hour)" *ngIf="hourToString(hour?.start) === 'night'">
            <a class="option">{{ formatTime(hour?.start) }}</a>
            <!-- <a class="option">{{ hour?.start }} - {{ hour?.end }}</a> -->
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
</div>
